import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import staffMemberReducer, { initialState } from '../reducers/staffMemberReducer';

export const StaffMemberContext = createContext();

const StaffMemberProvider = ({ children }) => {
  const useStaffMemberState = useReducer(staffMemberReducer, initialState);

  return (
    <StaffMemberContext.Provider value={[...useStaffMemberState]}>
      <ContextDevTool
        context={StaffMemberContext}
        id="StaffMemberContext"
        displayName="StaffMember Context"
      />
      {children}
    </StaffMemberContext.Provider>
  );
};

StaffMemberProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default StaffMemberProvider;
